import { render, staticRenderFns } from "./afterSaleRouter.vue?vue&type=template&id=9a758170&scoped=true&"
import script from "./afterSaleRouter.vue?vue&type=script&lang=js&"
export * from "./afterSaleRouter.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleRouter.vue?vue&type=style&index=0&id=9a758170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a758170",
  null
  
)

export default component.exports